const platformEnv = import.meta.env.VITE_APP_PLATFORM as string | undefined

export function detectPlatform(): string {
  if (platformEnv) return platformEnv.toLowerCase()

  try {
    if (typeof window === 'undefined') return 'web'
    const cap = (window as any).Capacitor
    const plat = cap?.getPlatform?.() || cap?.platform || cap?.Plugins?.Device?.getInfo?.().platform
    if (plat && typeof plat === 'string') {
      const lowered = plat.toLowerCase()
      if (lowered === 'ios' || lowered === 'android') return lowered
    }
    const ua = navigator.userAgent.toLowerCase()
    if (/android/.test(ua)) return 'android'
    if (/iphone|ipad|ipod/.test(ua)) return 'ios'
    return 'web'
  } catch {
    return 'web'
  }
}
